import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { LoginService } from 'src/app/core/services/login.service';
import { Component, EventEmitter, Injectable, Input, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTable, MatTableDataSource } from '@angular/material/table';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { ModelService } from 'src/app/core/services/model.service';
import { SubscriptionData } from 'src/app/model/subscription';
import { SubscriptionService } from 'src/app/core/services/subscription.service';

@Injectable({ providedIn: 'root' })
@Component({
    selector: 'tb-subscription-list',
    templateUrl: './subscription-list.component.html',
    styleUrls: ['./subscription-list.component.scss'],
})
export class SubscriptionListComponent {
    subscriptionFound: boolean = true;
    searchSubscription: string = '';
    displayedColumnSubscription: string[] = ['SubscriptionKey'];
    dataSourceSubscription: MatTableDataSource<SubscriptionData>;
    isComponentInitialized: boolean = false;
    listOfSubscription: SubscriptionData[];
    authorizationStored = this.loginService.getauthinfo();
    authorizationProperties: AuthorizationProperties = JSON.parse(this.authorizationStored);
    showFilterOptionsSubscription = true;
    copyOfSelectedAccount = '';

    @Input() selectedAccount;
    @Input() isSaveEvent;
    @Output() changeBackgroundSubscription = new EventEmitter<any>();
    @Output() openDrawer = new EventEmitter<any>();
    @Output() initializeData = new EventEmitter<any>();
    @Output() setSaveEvent = new EventEmitter();

    @ViewChild(MatTable) subscriptionsTable: MatTable<SubscriptionData>;

    _paginatorSubs: MatPaginator;
    @ViewChild('paginatorSubs') set paginatorSubs(contentSubs: MatPaginator) {
        if (contentSubs) {
            // initially setter gets called with undefined
            this._paginatorSubs = contentSubs;
            const paginatorIntl = this._paginatorSubs._intl;
            paginatorIntl.nextPageLabel = this.variable.nextPage;
            paginatorIntl.previousPageLabel = this.variable.previousPage;
            if (this.dataSourceSubscription) {
                this.dataSourceSubscription.paginator = this._paginatorSubs;
            }
        }
    }

    constructor(
        private subscriptionService: SubscriptionService,
        private loginService: LoginService,
        private workFlow: WorkFlowService,
        private variable: TranslatedVariables
    ) {}

    async ngOnInit() {
        await this.getSubscriptionsAssociated(this.selectedAccount);
        this.isComponentInitialized = true;
    }

    async ngOnChanges() {
        if (this.isComponentInitialized) {
            await this.getSubscriptionsAssociated(this.selectedAccount);
        }
    }

    async getSubscriptionsAssociated(selectedAccount: string) {
        if (this.isSaveEvent) {
            // Setto a false nel componente accountManagement la variabile isSaveEvent che alla modifica fa scattare l'hook ngOnChanges che recupera le info necessarie
            // Codice scritto cosi per evitare che la chiamata api venisse fatta 2 volte
            this.setSaveEvent.emit(false);
            return;
        }
        if (selectedAccount === '') return;
        this.copyOfSelectedAccount = this.selectedAccount;
        this.subscriptionService.getSubscriptionsIntersect(this.authorizationProperties.accountName, selectedAccount).subscribe(
            async (res) => {
                const opRes: boolean = res['Result'];
                if (!opRes || res['Content'].length === 0) {
                    this.subscriptionFound = false;
                    this.showFilterOptionsSubscription = false;
                    return;
                }
                this.listOfSubscription = res['Content'];
                this.dataSourceSubscription = new MatTableDataSource(this.listOfSubscription);
                this.dataSourceSubscription.paginator = this._paginatorSubs;
                this.subscriptionFound = true;
                this.showFilterOptionsSubscription = true;
                this.initializeData.emit(this.listOfSubscription);
            },
            (err) => {
                this.subscriptionFound = false;
                this.showFilterOptionsSubscription = false;
                this.workFlow.showMessage(this.variable.errorTitle, err.message);
            }
        );
    }

    clearSubscriptionSearch() {
        this.searchSubscription = '';
        this.dataSourceSubscription.filterPredicate = function (data, filter: string): boolean {
            return data.Description.toLowerCase().includes(filter) || data.SubscriptionKey.toLowerCase().includes(filter);
        };
        this.dataSourceSubscription.filter = this.searchSubscription.trim().toLowerCase();
        if (this.dataSourceSubscription.paginator) {
            this.dataSourceSubscription.paginator.firstPage();
        }
        this.subscriptionFound = true;
        this.showFilterOptionsSubscription = true;
    }

    applySubscriptionSearch(event: any) {
        let filterValue: string;
        filterValue = (event.target as HTMLInputElement).value;

        this.dataSourceSubscription.filterPredicate = function (data, filter: string): boolean {
            return data.Description.toLowerCase().includes(filter) || data.SubscriptionKey.toLowerCase().includes(filter);
        };
        this.dataSourceSubscription.filter = filterValue.trim().toLowerCase();

        if (this.dataSourceSubscription.filteredData.length === 0) {
            this.subscriptionFound = false;
            this.showFilterOptionsSubscription = false;
        } else {
            this.subscriptionFound = true;
            this.showFilterOptionsSubscription = true;
        }
    }
    doSomethingEvent(event: any) {
        this.updateTableSubscription(this.authorizationProperties.accountName, this.selectedAccount, event.value);
    }

    async updateTableSubscription(parentAccount: string, selectedAccount, selected: string) {
        this.subscriptionService.getSubscriptionsIntersect(parentAccount, selectedAccount).subscribe(
            (res) => {
                const opRes: boolean = res['Result'];
                if (!opRes || res['Content'].length === 0) {
                    return;
                } else {
                    let result = this.filterRoles(res['Content'], selected);
                    switch (selected) {
                        case 'CO-USER-ADMIN':
                        case 'USER-ADMIN':
                        case 'POWER-USER':
                        case 'POWER-USER-SCHEDULER':
                        case 'POWER-USER-REPORT':
                        case 'SECURITY-ADMIN':
                        case 'APPLICATION-ADMIN':
                            this.listOfSubscription = result;
                            this.dataSourceSubscription = new MatTableDataSource<SubscriptionData>(this.listOfSubscription);
                            break;
                        default:
                            this.listOfSubscription = res['Content'];
                            this.dataSourceSubscription = new MatTableDataSource<SubscriptionData>(this.listOfSubscription);
                            break;
                    }
                    this.showFilterOptionsSubscription = true;
                    this.initializeData.emit(this.listOfSubscription);
                    if (this.listOfSubscription.length === 0) {
                        this.subscriptionFound = false;
                        return;
                    }
                    this.subscriptionFound = true;
                }
            },
            (err) => {
                console.log(err);
            }
        );
    }

    filterRoles(listAccountAssociated: SubscriptionData[], role) {
        let filteredAccounts: SubscriptionData[] = [];
        for (let i = 0; i < listAccountAssociated.length; i++) {
            if (listAccountAssociated[i].Roles.some((x) => x === role)) {
                filteredAccounts.push(listAccountAssociated[i]);
            }
        }
        return filteredAccounts;
    }

    changeBackgroundSubscriptionEvent(subKey: string) {
        this.changeBackgroundSubscription.emit(subKey);
    }

    openDrawerEvent(row: any) {
        this.openDrawer.emit(row);
    }
}
